import * as constants from 'styles/constants';

export const StyleConstant = { ...constants };

export default function(key) {
  return StyleConstant[key];
}
